import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3471fa4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center justify-content-center",
  style: {"min-height":"300px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-3xl font-bold text-center text-gray-900 mb-12" }
const _hoisted_5 = { class: "d-flex gap-8 align-items-center justify-content-center" }
const _hoisted_6 = { class: "text-center title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["loading", "onClick"]
const _hoisted_11 = { class: "d-flex align-items-center justify-content-center mt-10" }

import { ref, onMounted, inject, nextTick, provide } from "vue";
import AccountService from "../../accounts/services/AccountService";
import { AccountTypesJp } from "@/core/types/AccountInfos";
import {
  ApplicationStatusType,
  ApplicationType,
} from "@/core/types/ApplicationInfos";
import {
  AccountRoleTypes,
  AccountStatusTypes,
} from "@/core/types/AccountInfos";
import { accountTypes } from "@/core/types/jp/verificationFinancial";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import VerificationService from "../../verification/services/VerificationService";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsCheck',
  setup(__props) {

const t = i18n.global.t;
const isLoading = ref(false);
const isLoadingMain = ref(false);
const pendingVerifications = ref<any>([]);
const data = ref<any>([
  {
    name: t("fields.marginTrading"),
    accountTypes: [AccountTypesJp.JpALPFX, AccountTypesJp.JpSTDFX],
    verificationAccType: accountTypes.margin,
    status: null,
  },
  {
    name: t("fields.cfdTrading"),
    accountTypes: [AccountTypesJp.JpALPCFD, AccountTypesJp.JpSTDCFD],
    verificationAccType: accountTypes.cfdTrading,
    status: null,
  },
  {
    name: t("fields.productTrading"),
    accountTypes: [AccountTypesJp.JpALPIND, AccountTypesJp.JpSTDIND],
    verificationAccType: accountTypes.productTrading,
    status: null,
  },
]);
const typeData = ref<any>([]);
const mainStep = inject<any>("mainStep");
const selectedAccountTypes = inject<any>("selectedAccountTypes");
const selectedVerification = inject<any>("selectedVerification");
const verificationData = inject<any>("verificationData");

const openAccount = async (item: any) => {
  selectedVerification.value = item;
  await nextTick();
  mainStep.value = 1;
};

const addToSelectedAccountArray = (item) => {
  if (selectedAccountTypes.value.includes(item.verificationAccType)) {
    selectedAccountTypes.value = selectedAccountTypes.value.filter(
      (type) => type !== item.verificationAccType
    );
  } else {
    selectedAccountTypes.value.push(item.verificationAccType);
  }
};

const fetchOpenedAccountData = async () => {
  try {
    const pendingData = await AccountService.queryApplications({
      statuses: [
        ApplicationStatusType.AwaitingApproval,
        ApplicationStatusType.Approved,
      ],
      type: ApplicationType.TradeAccount,
    });

    const liveData = await AccountService.queryAccounts({
      hasTradeAccount: true,
      status: AccountStatusTypes.Activate,
      roles: [
        AccountRoleTypes.Client,
        AccountRoleTypes.SuperAdmin,
        AccountRoleTypes.TenantAdmin,
        AccountRoleTypes.Wholesale,
        AccountRoleTypes.Guest,
      ],
    });

    const liveTypesData = liveData.data.map((item) => item.type);
    const pendingTypesData = pendingData.data.map(
      (item) => item.supplement.accountType
    );
    typeData.value = [...liveTypesData, ...pendingTypesData];
    data.value.forEach((item) => {
      if (item.accountTypes.some((item) => typeData.value.includes(item))) {
        item.status = VerificationStatusTypes.Approved;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

const fetchPendingVerification = async () => {
  try {
    const verificationRes =
      await VerificationService.getExistingVerifications();

    verificationData.value = verificationRes;

    pendingVerifications.value = verificationRes.filter(
      (item) => item.status !== VerificationStatusTypes.Approved
    );

    data.value.forEach((item) => {
      pendingVerifications.value.forEach((pendingItem) => {
        if (
          pendingItem.financial.accountTypes.includes(item.verificationAccType)
        ) {
          item.status = VerificationStatusTypes.Incomplete;
          typeData.value.push(item.verificationAccType);
        }
      });
    });
    console.log("data", data.value);
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  isLoadingMain.value = true;
  await fetchOpenedAccountData();
  await fetchPendingVerification();
  isLoadingMain.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (isLoadingMain.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ScaleLoader, { color: '#ffc730' })
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("action.openTradeAccount")), 1),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "card account-card h-100 text-center"
            }, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(item.name), 1),
              (item.status == _unref(VerificationStatusTypes).Approved)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      type: "info",
                      loading: isLoading.value,
                      class: "w-75 custom-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("status.active")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : (item.status !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        loading: isLoading.value,
                        class: "w-75 custom-btn",
                        onClick: ($event: any) => (openAccount(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("status.pending")), 1)
                        ]),
                        _: 2
                      }, 1032, ["loading", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        style: {"width":"40px","height":"40px"},
                        loading: isLoading.value,
                        onClick: ($event: any) => (addToSelectedAccountArray(item))
                      }, null, 8, _hoisted_10)
                    ]))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (typeData.value.length < 3)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                class: "w-25 custom-btn",
                loading: isLoading.value,
                disabled: _unref(selectedAccountTypes).length === 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openAccount(null)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("status.open")), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]))
}
}

})